
import { mapGetters } from 'vuex';

  export default {
  props:['currentUrl'],


    data() {
    return {
      prevLink:'',
      nextLink:'',
    }
  },
  computed: {
    ...mapGetters({
      paginationLinks: 'jobSearch/paginationLinks'
    })
  },
  mounted() {
    this.getLinks()
  },
    methods: {
      getLinks() {
        this.paginationLinks.forEach((url, index) => {
        if(url === this.$props.currentUrl) {
          this.prevLink = this.paginationLinks[index-1]
          this.nextLink = this.paginationLinks[index+1]
          if(index === 0) {
            this.prevLink = null
          }
          if(index === this.paginationLinks.length+1){
            this.nextLink = null
          }
        }
      })
      }
    }
  }
